
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { getDefaultTaxesApplied } from '@/utils/getters';
import TaxRateSelect from '@/components/shared/TaxRateSelect.vue';
import ToggleSwitch from '@/components/shared/ToggleSwitch.vue';

@Component<ItemTaxOverwrite>({
	components: {
		TaxRateSelect,
		ToggleSwitch
	}
})
export default class ItemTaxOverwrite extends Vue {
	@Getter('getRestaurant', { namespace: 'auth' }) private restaurant!: Restaurant;
	@Prop({ type: Object, default: () => {} }) private itemTaxRates!: Taxes;
	@Watch('itemTaxRates')
	private onItemTaxRatesChange(newVal: Taxes): void {
		this.showTaxOverwrite = !!newVal;
	}

	private showTaxOverwrite: boolean = false;

	private get defaultTaxesApplied(): string {
		return getDefaultTaxesApplied(this.restaurant);
	}

	private created(): void {
		if(this.itemTaxRates) {
			this.showTaxOverwrite = true;
		}
	}

	private updateItemTaxRates(): void {
		if (!this.showTaxOverwrite) {
			this.$emit('update-item-tax-rates', null);
		}
	}
}
